import {PRICES_CITIES} from "@pg-rp/navigation";

type PricesCitySlug = (typeof PRICES_CITIES)[number]["slug"];

export const PRICES_CITIES_REGION_IDS: Record<PricesCitySlug, number> = {
    bialystok: 9692,
    bydgoszcz: 22550,
    gdansk: 46083,
    katowice: 31600,
    kielce: 36190,
    krakow: 11158,
    lublin: 13220,
    lodz: 16187,
    olsztyn: 26804,
    poznan: 30892,
    rzeszow: 33659,
    szczecin: 32657,
    warszawa: 8647,
    wroclaw: 26955
};

export const getPricesCityRegionId = (slug: string): number | null => {
    return slug in PRICES_CITIES_REGION_IDS ? PRICES_CITIES_REGION_IDS[slug as PricesCitySlug] : null;
};
import {PRICES_CITIES} from "@pg-rp/navigation";

type PricesCitySlug = (typeof PRICES_CITIES)[number]["slug"];

export const PRICES_CITIES_REGION_IDS: Record<PricesCitySlug, number> = {
    bialystok: 9692,
    bydgoszcz: 22550,
    gdansk: 46083,
    katowice: 31600,
    kielce: 36190,
    krakow: 11158,
    lublin: 13220,
    lodz: 16187,
    olsztyn: 26804,
    poznan: 30892,
    rzeszow: 33659,
    szczecin: 32657,
    warszawa: 8647,
    wroclaw: 26955
};

export const getPricesCityRegionId = (slug: string): number | null => {
    return slug in PRICES_CITIES_REGION_IDS ? PRICES_CITIES_REGION_IDS[slug as PricesCitySlug] : null;
};
